import { TimeContolDataService } from './shared/time-contol.data.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { Const, EtapaBase } from '@app/shared';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'iw-time-control',
  templateUrl: './time-control.component.html',
  styleUrls: ['./time-control.component.scss'],
  providers: [TimeContolDataService]
})
export class TimeControlComponent implements OnInit {
  // Variables para determinar la carga de los datos y muestra un mensaje de cargando
  loadingFinishStages = false;
  // contiene todas las etapas del sistema
  stages: Array<EtapaBase> = [];
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
    constructor(
    private as: AuthenticationService,
    private toastr: ToastrService,
    private tcds: TimeContolDataService
    ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesions
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );
    this.loadingStages();
  }
  loadingStages() {
    if (this.activateAction.review) {
      this.tcds.getStage().subscribe(stages => {
        this.stages = stages;
      });
    } else {
      this.toastr.error('Usted no posee permisos para ver las etapas del tramite', 'Permiso denegado');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/time-control.component.ts